import React, {Component} from 'react'
import styles from './Calendar.css'
import moment from 'moment'
import 'react-dates/initialize'
import {DayPicker} from 'react-dates'
import './datepicker.css'
import './datepicker-overrides.css'
import PropTypes from "prop-types"
import MenuToggle from "../MenuToggle/MenuToggle"
import Svg from "../Svg/Svg"
import {Icon} from '../../constants/consts-types'
import {getMomentLocale} from "../../services/service-moment-locale"

class Calendar extends Component {
  static propTypes = {
    date: PropTypes.object.isRequired,
    onDateChanged: PropTypes.func.isRequired,
    onCloseCalendar: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context)

    this.state = {
      daySize: 39,
      wrapperHeight: 39 * 6 + 100,
      entered: false
    }

    this.onCloseClick = this.onCloseClick.bind(this)
    this.renderDayContents = this.renderDayContents.bind(this)
  }

  handleSizing = () => {

    const availableWidth = window.innerWidth - 40
    const availableHeight = window.innerHeight - 100 - 100
    const daySize = Math.floor(
      Math.min(
        Math.min(availableWidth / 7,  availableHeight / 7),
        80
      )
    )
    const wrapperHeight = daySize * 6 + 100
    
    this.setState({daySize, wrapperHeight})
  }

  componentDidMount() {
    this.setMomentLocale()

    this.handleSizing()

    setTimeout(() => {
      this.setState({
        entered: true
      })
    }, 0)
  }

  componentDidUpdate(prevProps) {
    if(prevProps.language !== this.props.language) {
      this.setMomentLocale()
    }
  }

  setMomentLocale() {
    moment.updateLocale(this.props.language, getMomentLocale(this.props.language))
  }

  onCloseClick() {
    this.props.onCloseCalendar()
  }

  renderDayContents(day) {
    const isToday = moment(day).isSame(this.props.date, "day")
    if(isToday) {
      return <span className="CalendarDay__day--isfuture">{day.format('D')}</span>
    } else {
      return <span>{day.format('D')}</span>
    }
  }

  render() {
    const {entered} = this.state

    return (
      <div className={entered ? styles.CalendarOpen : styles.Calendar}>
        <div className={styles.header}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                <div className={styles.buttonCloseContainer}>
                  <MenuToggle
                    isOpen={true}
                    onMenuToggle={this.onCloseClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.centered}>
          <div className="smk-datepicker" style={{height: `${this.state.wrapperHeight}px`}}>
            <DayPicker
              initialVisibleMonth={() => this.props.date}
              onDayClick={this.props.onDateChanged}
              numberOfMonths={1}
              noBorder
              navPrev={<Svg id={Icon.ARROW_LONG_LEFT} />}
              navNext={<Svg id={Icon.ARROW_LONG_RIGHT} />}
              daySize={this.state.daySize}
              firstDayOfWeek={1}
              hideKeyboardShortcutsPanel={true}
              renderDayContents={this.renderDayContents}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Calendar



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js